import React, { useEffect, useState, useRef } from 'react';
import { Button, notification, Spin } from 'antd';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { getCore, Task } from 'cvat-core-wrapper';
import { CombinedState } from 'reducers';

const core = getCore();

const TaskLastJob: React.FC = () => {
    const history = useHistory();
    const task = useSelector((state: CombinedState) => state.tasks.current[0]);
    const [taskInstance, setTaskInstance] = useState<Task | null>(null);
    const [fetchingTask, setFetchingTask] = useState(true);
    const mounted = useRef(false);

    const receiveTask = (): void => {
        if (task) {
            core.tasks
                .get({ id: task.id })
                .then(([fetchedTask]: Task[]) => {
                    if (fetchedTask && mounted.current) {
                        setTaskInstance(fetchedTask);
                    }
                })
                .catch((error: Error) => {
                    if (mounted.current) {
                        notification.error({
                            message: 'Could not receive the requested reference from the server',
                            description: error.toString(),
                        });
                    }
                })
                .finally(() => {
                    if (mounted.current) {
                        setFetchingTask(false);
                    }
                });
        }
    };

    useEffect(() => {
        mounted.current = true;
        receiveTask();

        return () => {
            mounted.current = false;
        };
    }, [task]);

    if (fetchingTask) {
        return <Spin size='default' />;
    }

    const jobs = taskInstance?.jobs || [];

    return (
        <div>
            <Button
                disabled={fetchingTask || !taskInstance || jobs.length === 0}
                className='cvat-item-open-task-button'
                type='primary'
                size='large'
                ghost
                onClick={() => history.push(`/tasks/${task?.id}/jobs/${jobs[0].id}`)}
            >
                Open
            </Button>
        </div>
    );
};

export default TaskLastJob;
